/* @flow */

import { type EtapasId, type Pedido } from './types';

const filtrarPedidosPorEtapasId = (etapasId: EtapasId[]) => (pedido: Pedido) => (
    etapasId.includes(pedido.etapasId)
);

export default filtrarPedidosPorEtapasId;
